export default __webpack_public_path__ + "static/media/appGallery-de.9cd3dbf1.svg";